fx.ns("repositories", class AlbumsRepository extends fx.ModelArray {

	constructor()
	{
		super([]);
	}

    // --- 
    loadAlbums(creationid, accountid, connectionid)
    {
        if (this.length == 0)
        {
            this.post( "/app/photos",
                {
                    action: "albums",
                    creationid : creationid,
                    accountid: accountid,
                    connectionid : connectionid
                },
                this._onLoadAlbums);
        }
        else
            this.event("albums-loaded");
    }

    _onLoadAlbums(data)
    {
        if (data.error)
            this.event("albums-error", data.error);
        else
        {
            if (data.length > 0)
            {
                for (let i = 0; i < data.length; i++)
                {
                    // there is no model for albums on PHP side, so we create our own
                    let album = new models.Album({
                        id : data[i].id,
                        count : data[i].nbPhotos,
                        cover_url : data[i].thumb,
                        photos : [],
                        loaded : false,
                        selected : false
                    });

                    this.addItem(album);
                }
            }

            this.event("albums-loaded");
        }
    }

    loadAlbumPhotos(id, accountid, connectionid)
    {
        let album = this.find({id : id});

        if (album && !album.isLoaded)
        {
            this.post( "/app/photos",
                {
                    action: "photoalbums",
                    accountid: accountid,
                    albumid: id,
                    connectionid : connectionid
                },
                this._onLoadPhotosAlbum);
        }
        else
            this.event("album-photos-loaded");    
    }

    _onLoadPhotosAlbum(data)
    {
        if (data.error)
            this.event("album-photos-error", data.error);
        else
        {
            let album = this.find({id : data.id});
            if (album)
            {
                for (let i = 0; i < data.photos.length; i++)
                    album.photos.addItem( new models.PhotoAlbum(data.photos.getItemAt(i)) );
            }
                
            album.isLoaded = true;

            this.event("album-photos-loaded");    
        }
    }

    copyPhotos(files, accountid, creationid, connectionid)
    {
        let photos = [];

		for (let i = 0; i < files.length; i++)
		 	photos.push(files[i].JSON);

        this.post( "/app/photos",
                    {
                        action: "copyphotos",
                        accountid: accountid,
                        creationid: creationid,
                        photos: photos,
                        connectionid : connectionid
                    },
                    this._onCopyPhotos,
                    {timeout : 60000});
    }

    _onCopyPhotos(data)
    {
        if (data.error)
            this.event("album-photos-copy-error", data.error);
        else
            this.event("album-photos-copied", data);
    }

});